import { useSelector } from "react-redux";
import { useLocation } from "react-router-dom";

import { Center, Link } from "@seneca/senekit";

import { regionMetas } from "common/static/regions/regionMetas";
import { MODAL_ROUTES } from "routing/routes";

import { getRegion, DEFAULT_REGION } from "features/regions/selectors";

export default function FlagRegionLink() {
  const location = useLocation();
  const region = useSelector(getRegion) || DEFAULT_REGION;

  const Flag = (regionMetas as any)[region].FlagComponent;

  return (
    <Link
      to={MODAL_ROUTES.CHOOSE_REGION.path}
      state={MODAL_ROUTES.CHOOSE_REGION.buildState({ background: location })}
    >
      <Center>
        <Flag alt={region} width={["25px", "30px"]} />
      </Center>
    </Link>
  );
}
